// import { Uid } from "./Uid";
import { User } from "./User";

export type NotificationType = 'Text' | 'Voice' | 'Images' | 'Docs' | 'Emoticon' | 'RoomAdded' | 'Info' | 'CallStart' | 'VideoRecording' | 'Emoji' | 'BoardPost' | 'CalendarEvent';

/** 통지 센터 탭/아이콘 분류 — 채널 탭은 channelId 유무, 게시판/캘린더 탭은 source 로 필터 */
export type NotificationSource = 'chat' | 'task' | 'board' | 'calendar';

//notification
export class Notification {
  static COL = 'notifications';
  id: string;

  created: Date = new Date();
  isNew = true;
  isMentioned?: boolean = false;
  subtitle?: string;

  // ── 통지 센터 재설계용 enrich 필드 (생성 시점에 채움; 구 데이터엔 없음 → roomId 폴백) ──
  /** 소속 워크스페이스 (워크스페이스별 표시/필터) */
  workspaceId?: string;
  /** 콘텐츠 타입 (아이콘 + 게시판/캘린더 탭 필터) */
  source?: NotificationSource;
  /** 채널 스코프일 때 채널 ID (채널 탭 필터). 채팅=roomId, 게시판/캘린더=소속 채널 */
  channelId?: string | null;
  /** 클릭 시 이동 경로 (채널/게시판/캘린더) — 푸시 link 와 동일 개념 */
  targetRoute?: string;
  /** 게시판 알림: 게시판 ID + 게시글 ID — 클릭 시 해당 게시글로 deep link */
  boardId?: string | null;
  postId?: string | null;
  /** 캘린더 리마인더: 시작까지 남은 분 (0=지금). 알림 제목의 시간 표현 렌더용 */
  minutes?: number;

  constructor(
    public type: NotificationType,
    public toUserId: string,
    public roomId: string | null,
    public roomName: string | null,
    public messageId: string | null,
    public parentMessageId: string | null,
    public replyToMessageId: string | null,
    public fromUser: User | null) {
    this.id = uuid();
  }
}

function uuid(): string {
  //uuidv4
  return 'xxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}